import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderComponent, withProps } from 'recompose';
import BarberUserAddBankAccountWrapper from '../../barber/wrappers/barberUserAddBankAccountWrapper';
import withoutPageHeader from '../../common/hoc/withoutPageHeader';
import MFWrapper from '../../common/MFWrapper';
import SimpleHeader from '../headers/simpleHeader';
import ShopUserAddBankAccountWrapper from '../wrappers/shopUserAddBankAccountWrapper';
import HeaderDropdown from './headerDropdown';
import { shouldOpenNewPaymentProcessing } from './selectors';
import { withRefetchBankAccountOnUnmount } from '../../common/hoc/paymentInfoSetupStatus';
import { withFeatureFlags } from '../../../modules/infra/feature-flags';
import { containerApp } from '../../../main';

// eslint-disable-next-line import/no-unresolved
const PaymentProcessing = React.lazy(() => import('paymentProcessing/App'));

const WrappedPaymentProcessing = withoutPageHeader(props => (
  <MFWrapper>
    <SimpleHeader heading="Payment Processing">
      <HeaderDropdown title="Payment Processing" />
    </SimpleHeader>
    <PaymentProcessing
      basename={props.basename}
      featureFlags={props.featureFlags}
      isContainerApp={containerApp.isActive()}
    />
  </MFWrapper>
));

WrappedPaymentProcessing.propTypes = {
  basename: PropTypes.string.isRequired,
};

const baseEnhancer = compose(
  withFeatureFlags,
  connect(state => ({
    shouldOpenNewPaymentProcessing: shouldOpenNewPaymentProcessing(state),
  })),
);

const shopEnhancer = compose(
  baseEnhancer,
  withProps(() => ({
    basename: '/settings/bank-account',
  })),
  branch(
    props => !props.shouldOpenNewPaymentProcessing,
    renderComponent(ShopUserAddBankAccountWrapper)
  ),
  withRefetchBankAccountOnUnmount,
);

const shopDashboardEnhancer = compose(
  shopEnhancer,
  withProps(() => ({
    basename: '/settings/payment-processing',
  })),
);

const barberEnhancer = compose(
  baseEnhancer,
  withProps(() => ({
    basename: '/barber/settings/bank-account',
  })),
  branch(
    props => !props.shouldOpenNewPaymentProcessing,
    renderComponent(BarberUserAddBankAccountWrapper)
  )
);

const barberDashboardEnhancer = compose(
  barberEnhancer,
  withProps(() => ({
    basename: '/barber/settings/payment-processing',
  })),
);

const ShopPaymentProcessing = shopEnhancer(WrappedPaymentProcessing);
const ShopPaymentProcessingDashboard = shopDashboardEnhancer(WrappedPaymentProcessing);

const BarberPaymentProcessing = barberEnhancer(WrappedPaymentProcessing);
const BarberPaymentProcessingDashboard = barberDashboardEnhancer(WrappedPaymentProcessing);

export {
  ShopPaymentProcessing,
  ShopPaymentProcessingDashboard,
  BarberPaymentProcessing,
  BarberPaymentProcessingDashboard,
};
